import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import type { UpdateNotificationPreferenceRequestModel } from '@xver/apis/v1/notification-preferences/model';
import { getErrorMessage } from '@xver/utils/error';
import { useTranslation } from 'react-i18next';

import { NOTIFICATION_PREFERENCES_QUERY_KEY } from './useNotificationPreferencesQuery';

export function useUpdateNotificationPreferencesMutation(options?: { silent?: boolean }) {
    const { t } = useTranslation('settings');
    const queryClient = useQueryClient();
    const silent = options?.silent;

    return useMutation({
        mutationFn: (payload: UpdateNotificationPreferenceRequestModel) =>
            Endpoints.v1.NotificationPreferences.updateNotificationPreferences(payload),
        onSuccess: async () => {
            if (!silent) {
                notifications.show({
                    title: t('toast.saveTitle'),
                    message: t('toast.saveMessage'),
                    icon: <IconCheck size={18} color="#22c55e" />,
                });
            }
            await queryClient.invalidateQueries({ queryKey: NOTIFICATION_PREFERENCES_QUERY_KEY });
        },
        onError: (err: unknown) => {
            notifications.show({
                title: t('toast.errorTitle'),
                message: getErrorMessage(err) ?? t('toast.errorMessage'),
                icon: <IconExclamationCircle size={18} color="#eb5757" />,
            });
        },
    });
}
